// src/components/ui/DataTableCard.jsx

import React from 'react';
import { PAGE, getCardStyle } from './pageTheme';

export default function DataTableCard({ children, footer, style }) {
  return (
    <div
      style={{
        ...getCardStyle(),
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        padding: 0,
        ...style,
      }}
    >
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          overscrollBehavior: 'contain',
        }}
      >
        {children}
      </div>

      {footer && (
        <div
          style={{
            flexShrink: 0,
            padding: '14px 20px',
            borderTop: `1px solid ${PAGE.colors.line}`,
            background: PAGE.colors.surface,
          }}
        >
          {footer}
        </div>
      )}
    </div>
  );
}
